var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarning = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 15,
  viewBox: "0 0 17 15",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 15H17L8.5 0L0 15ZM9.5 13H7.5V11H9.5V13ZM9.5 10H7.5V6H9.5V10Z",
  fill: "#DB4437"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.3bc6bfa3.svg";
export { ForwardRef as ReactComponent };